<!-- <a
*ngIf="hasPermit"
[class]="class"
(click)="onClick()"
>
<ng-content></ng-content>
</a> -->
<div
*ngIf="hasPermit"
>
<ng-content></ng-content>
</div>